<template>
    <div>
        <loading-overlay :loading="loading"></loading-overlay>

        <!-- Bank Name -->
        <v-select
            label="Recipient Bank Name"
            v-model="copyOfRecipientInfo.bank_code"
            @change="bankSelected"
            v-validate="'required|bank-name'"
            :items="banks"
            item-value="bank_code"
            item-text="bank_name"
            :error-messages="errors.first('bank name')"
            outlined
            color="primary"
        />

        <!-- Account Type -->
        <!-- DISABLED UNTIL RECIPIENT ACCOUNT TYPE IS ADDED TO API -->
        <!-- <v-select
            label="Bank Account Type"
            @change="$emit('recipient-updated', copyOfRecipientInfo)"
            :items="[
                { text: 'Checking', value: 'checking' },
                { text: 'Savings', value: 'saving' }
            ]"
            outlined
        >
        </v-select> -->

        <!-- Account Number -->
        <v-text-field
            label="Recipient Account Number"
            placeholder="0724394"
            v-model="copyOfRecipientInfo.account_number"
            name="account number"
            @change="$emit('recipient-updated', copyOfRecipientInfo)"
            v-validate="'required|numeric|confirmed:account-number-confirm'"
            :error-messages="errors.first('account number')"
            outlined
            color="primary"
        />

        <!-- Account Number 2 -->
        <v-text-field
            label="Re-Enter Recipient Account Number"
            v-model="accountNumberConfirm"
            name="account confirmation"
            placeholder="0724394"
            ref="account-confirmation"
            outlined
        />

        <!-- Name -->
        <v-text-field
            label="Recipient Name"
            placeholder="John Smith"
            name="name"
            v-model="copyOfRecipientInfo.name"
            @change="$emit('recipient-updated', copyOfRecipientInfo)"
            v-validate="'required|name|two-words'"
            :error-messages="errors.first('name')"
            outlined
            color="primary"
        />

        <!-- Save Recipient Details -->
        <v-switch
            v-if="continueButtonText !== 'SAVE'"
            label="Save Recipient Details?"
            v-model="canSaveRecipient"
            color="primary"
        />

        <v-card-actions class="pb-6">
            <v-spacer />
                <v-btn
                    x-large
                    color="primary"
                    dark
                    class="px-12"
                    @click="validateThenEmit"
                >
                {{ continueButtonText }}
                </v-btn>
            <v-spacer />
        </v-card-actions>
    </div>
</template>

<script>
    export default {
        props: {
            continueButtonText: {
                type: String,
                default: 'CONTINUE'
            },
            recipientInfo: Object
        },
        data: data,
        mounted: mounted,
        methods: getMethods(),
        watch: getWatched()
    }

    function getWatched(){
        return {
            recipientInfo: {
                handler: recipientInfo,
                immediate: true
            }
        }

        function recipientInfo(){
            const vm = this;
            if(vm.recipientInfo){
                Vue.set(vm, 'copyOfRecipientInfo', vm.recipientInfo);
                vm.accountNumberConfirm = vm.copyOfRecipientInfo.account_number;
            }
            if(Object.keys(this.recipientInfo).length){
                Vue.nextTick(() => {
                    vm.$validator.validateAll();
                });
            }
        }
    }

    function data(){
        return {
            canSaveRecipient: false,
            banks: [],
            copyOfRecipientInfo: {
                bank_code: ''
            },
            accountNumberConfirm: '',
            loading: false,
        }
    }

    function mounted(){
        const vm = this;
        vm.positionBottomButton(13);
        if(vm.recipientInfo) {
            vm.copyOfRecipientInfo = vm.recipientInfo;
        }
        vm.getGhanianBanks();

    }

    function getMethods(){
        return {
            getGhanianBanks: getGhanianBanks,
            validateThenEmit: validateThenEmit,
            bankSelected: bankSelected
        };

        function bankSelected(){
            console.log(this.copyOfRecipientInfo)
        }

        function getGhanianBanks(){
            const vm = this;
            vm.loading = true;
            Vue.backendApi().banks().ghanian().listGhanianBanks().then(success, error);

            function success(response){
                vm.loading = false;
                vm.banks = response.data;
                if(!vm.copyOfRecipientInfo.bank_code){
                    vm.copyOfRecipientInfo.bank_code = vm.banks[0].bank_code;
                }
            }

            function error(error){
                vm.loading = false;
                vm.$swal({
                    type: 'error',
                    title: 'Error retrieving banks',
                    text: error
                });
            }
        }

        function validateThenEmit(){
            const vm = this;
            vm.$validator.validateAll().then(submitIfValid);
            function submitIfValid(formIsValid){
                if(formIsValid){
                    vm.$emit('continue', vm.copyOfRecipientInfo);
                    if(vm.canSaveRecipient){
                        vm.$emit('saveRecipient', vm.copyOfRecipientInfo);
                    }
                }
            }
        }
    }
</script>

<style scoped>
</style>